module.exports = __webpack_public_path__ + "static/img/twitter.d783762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/twitter.png
// module id = Ednz
// module chunks = 1